/** NRC IRAP Clean Technology stream. */
export const IRAP_CLEAN_TECH_TASKS = [
  {
    id: 1,
    name: "Clean tech eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm project meets clean technology definition", completed: false },
      { id: "1-2", name: "Meet with IRAP ITA to discuss fit", completed: false },
      { id: "1-3", name: "Define TRL and commercialization path", completed: false },
    ],
  },
  {
    id: 2,
    name: "Project proposal",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft technical work plan and milestones", completed: false },
      { id: "2-2", name: "Prepare budget (labour, contractors, equipment)", completed: false },
      { id: "2-3", name: "ITA review and revision", completed: false },
    ],
  },
  {
    id: 3,
    name: "Agreement & reporting",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Sign contribution agreement", completed: false },
      { id: "3-2", name: "Submit periodic progress and financial reports", completed: false },
    ],
  },
];

/** SDTC — Sustainable Development Technology Canada. */
export const SDTC_TASKS = [
  {
    id: 1,
    name: "Seed / Start-up / Scale assessment",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Determine applicable SDTC fund (Seed, Start-up, Scale)", completed: false },
      { id: "1-2", name: "Confirm clean technology and Canadian incorporation", completed: false },
      { id: "1-3", name: "Prepare initial pitch / expression of interest if required", completed: false },
    ],
  },
  {
    id: 2,
    name: "Full application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft technology, market, and environmental case", completed: false },
      { id: "2-2", name: "Build project budget and financing plan (matching funds)", completed: false },
      { id: "2-3", name: "Secure letters of support from partners/investors", completed: false },
    ],
  },
  {
    id: 3,
    name: "Due diligence & award",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Respond to SDTC due diligence requests", completed: false },
      { id: "3-2", name: "Execute funding agreement and reporting schedule", completed: false },
    ],
  },
];

/** Clean Technology ITCs (CT ITC, CTM ITC, CCUS, Clean Hydrogen) — tax credit advisory. */
export const CLEAN_TECH_ITC_TASKS = [
  {
    id: 1,
    name: "ITC eligibility review",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Identify applicable ITC (CT, CTM, CCUS, Hydrogen)", completed: false },
      { id: "1-2", name: "Map eligible property and project expenditures", completed: false },
      { id: "1-3", name: "Confirm labour requirements and joint venture rules", completed: false },
    ],
  },
  {
    id: 2,
    name: "Documentation & registration",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Gather capital asset and project cost records", completed: false },
      { id: "2-2", name: "Complete pre-registration / filing steps with CRA", completed: false },
      { id: "2-3", name: "Coordinate with client's accountant on claim", completed: false },
    ],
  },
  {
    id: 3,
    name: "Claim & audit support",
    completed: false,
    subtasks: [
      { id: "3-1", name: "File ITC claim with tax return", completed: false },
      { id: "3-2", name: "Respond to CRA queries if reviewed", completed: false },
    ],
  },
];
